// Money / number formatting shared across persona screens (mirrors the helpers
// in the portal prototype: money / moneyK).

export function money(n: number | null | undefined): string {
  return '$' + Number(n || 0).toLocaleString();
}

// Compact money: $58.9K / $707K / $42
export function moneyK(n: number | null | undefined): string {
  const v = Number(n || 0);
  if (v >= 1000) return '$' + (v / 1000).toFixed(v >= 10000 ? 0 : 1) + 'K';
  return '$' + v;
}

export function pct(used: number, total: number): number {
  return total > 0 ? Math.round((used / total) * 100) : 0;
}
